import { cn } from '../../lib/cn';
import type { OrchestrationRow } from '../../enterpriseintegration/framework';

type Props = { workflows?: OrchestrationRow[] };

export function ServiceOrchestrationPanel({ workflows = [] }: Props) {
  return (
    <div className="space-y-2">
      {workflows.map((w) => (
        <div key={w.name} className="rounded-lg border border-slate-200 p-3 dark:border-slate-700">
          <div className="flex items-center justify-between gap-3">
            <div>
              <p className="text-sm font-medium">{w.name}</p>
              <p className="text-xs text-slate-500">{w.capability} · {w.steps} steps</p>
            </div>
            <span className={cn(
              'shrink-0 rounded-full px-2 py-0.5 text-xs font-medium',
              w.status === 'running' ? 'bg-brand-50 text-brand-700 dark:bg-brand-950 dark:text-brand-300' :
              w.status === 'armed' ? 'bg-warning-50 text-warning-700 dark:bg-warning-950 dark:text-warning-300' :
              'bg-slate-100 text-slate-600 dark:bg-slate-800 dark:text-slate-400',
            )}>
              {w.status}
            </span>
          </div>
        </div>
      ))}
    </div>
  );
}
